import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { router } from './router';
import App from './App.vue';
import './style.css';

// The Vue sub-app mounts into #dvs-app — either the standalone
// /dvs/index.html (when accessed directly) or the existing
// public/index.html (when an admin/scorer navigates to a feature
// that's been migrated to the framework).
const mountPoint = document.getElementById('dvs-app');
if (mountPoint) {
    createApp(App)
        .use(createPinia())
        .use(VueQueryPlugin)
        .use(router)
        .mount(mountPoint);
}
